import { TableBody as TBody } from "@mui/material";

import RowAddSecret from "./RowSecret/RowAddSecret";
import RowSecret from "./RowSecret/RowSecret";

// ----------------------------------------------------------------------

export type RowSecretType = {
	name: string;
	secretKey: string;
	createdAt: string;
	id: string;
	isClient?: boolean;
};

type Props = {
	data: RowSecretType[];
};

export default function TableBody({ data }: Props) {
	return (
		<TBody>
			{data.map((row, index) => (
				<RowSecret {...row} key={index} />
			))}
			{data.length < 6 && <RowAddSecret secretsNumber={data.length - 1} />}
		</TBody>
	);
}
